"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.equalsIgnoreCase = void 0;
/**
 * Converts both strings to upper case and compares them.
 * undefined and null are treated equally.
 *
 * @returns true if both strings are undefined OR if they equal ignoring case
 */
var equalsIgnoreCase = function (str1, str2) {
    return str1 == null
        ? str2 == null
        : str2 != null && str1.toUpperCase() === str2.toUpperCase();
};
exports.equalsIgnoreCase = equalsIgnoreCase;
